import { render, staticRenderFns } from "./NlpPricingV2.vue?vue&type=template&id=797d9191&scoped=true"
import script from "./NlpPricingV2.vue?vue&type=script&lang=js"
export * from "./NlpPricingV2.vue?vue&type=script&lang=js"
import style0 from "./NlpPricingV2.vue?vue&type=style&index=0&id=797d9191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d9191",
  null
  
)

export default component.exports